import React, { FC } from 'react'
import Helmet from 'react-helmet'
import LangInfo from '../../../components/setting/LangInfo'
import { Link, useParams } from 'react-router-dom'
import { setPath } from '../../../../utils/url'
import { LangValue } from '../../../../states/types/common'
import { URL } from '../../../constants/url'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'

const Index: FC = () => {
  const { language } = useParams<{ language: LangValue }>()

  const {
    login,
  } = useSelector((state: RootState) => (state))

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - ${login.role_name === "管理者" ? "管理者" : "共通"}設定 - 言語設定（配信メール・通知）`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        <Link
          to={setPath(URL.SETTING_COMMON.path, language)}
        >
          {`${login.role_name === "管理者" ? "管理者" : "共通"}設定`}
        </Link>
        &nbsp;&gt;&nbsp;
        言語設定（配信メール・通知）
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          言語設定（配信メール・通知）
        </h1>
      </section>
      <section className="page_description">
        <p>
          Qaseeからの配信されるメールや通知で表示される言語を設定します。
        </p>
        <p>
          設定は、会社全体に反映されます。
        </p>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            <LangInfo />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
